import { render, staticRenderFns } from "./ServiceHelp.vue?vue&type=template&id=26252b4c&scoped=true"
import script from "./ServiceHelp.vue?vue&type=script&lang=js"
export * from "./ServiceHelp.vue?vue&type=script&lang=js"
import style0 from "./ServiceHelp.vue?vue&type=style&index=0&id=26252b4c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26252b4c",
  null
  
)

export default component.exports